var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMilkIcon = function SvgMilkIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_389_10618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 1.3335H6.66683",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 1.3335V3.19283C1.99982 3.71936 1.84394 4.23409 1.55184 4.67216L1.1145 5.32816C0.822274 5.76642 0.666386 6.28141 0.666504 6.80816V13.3335C0.666504 13.6871 0.80698 14.0263 1.05703 14.2763C1.30708 14.5264 1.64622 14.6668 1.99984 14.6668H5.99984C6.35346 14.6668 6.6926 14.5264 6.94265 14.2763C7.19269 14.0263 7.33317 13.6871 7.33317 13.3335V6.8075C7.33316 6.28097 7.17727 5.76623 6.88517 5.32816L6.44784 4.67216C6.15561 4.2339 5.99972 3.71892 5.99984 3.19216V1.3335",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 9.99994C1.19435 9.77888 1.7609 9.66504 2.33317 9.66504C2.90544 9.66504 3.47199 9.77888 3.99984 9.99994C4.52767 10.2211 5.09423 10.3349 5.6665 10.3349C6.23878 10.3349 6.80534 10.2211 7.33317 9.99994",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_389_10618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 16,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMilkIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MilkIcon.a92d6f63.svg";
export { ForwardRef as ReactComponent };